// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/vision_shotlist_preset.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/vision_shotlist_preset.proto.
 */
export const file_vision_shotlist_v1_vision_shotlist_preset: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vc2hvdGxpc3QvdjEvdmlzaW9uX3Nob3RsaXN0X3ByZXNldC5wcm90bxIZcHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MSJEChRWaXNpb25TaG90bGlzdFByZXNldBINCgV2YWx1ZRgBIAEoCRINCgVsYWJlbBgCIAEoCRIOCgZjdXN0b20YAyABKAgirgIKGVZpc2lvblNob3RsaXN0UHJlc2V0QmFua3MSQwoKZnJhbWVfc2l6ZRgBIAMoCzIvLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVmlzaW9uU2hvdGxpc3RQcmVzZXQSPgoFYW5nbGUYAiADKAsyLy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvblNob3RsaXN0UHJlc2V0EkgKD2NhbWVyYV9tb3ZlbWVudBgDIAMoCzIvLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVmlzaW9uU2hvdGxpc3RQcmVzZXQSQgoJZXF1aXBtZW50GAQgAygLMi8ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90bGlzdFByZXNldCqKAgocVmlzaW9uU2hvdGxpc3RQcmVzZXRDYXRlZ29yeRIrCidWSVNJT05fU0hPVExJU1RfUFJFU0VUX0NBVEVHT1JZX1VOS05PV04QABIuCipWSVNJT05fU0hPVExJU1RfUFJFU0VUX0NBVEVHT1JZX0ZSQU1FX1NJWkUQARIpCiVWSVNJT05fU0hPVExJU1RfUFJFU0VUX0NBVEVHT1JZX0FOR0xFEAISMwovVklTSU9OX1NIT1RMSVNUX1BSRVNFVF9DQVRFR09SWV9DQU1FUkFfTU9WRU1FTlQQAxItCilWSVNJT05fU0hPVExJU1RfUFJFU0VUX0NBVEVHT1JZX0VRVUlQTUVOVBAEYgZwcm90bzM");

/**
 * @generated from message protos.vision.shotlist.v1.VisionShotlistPreset
 */
export type VisionShotlistPreset = Message<"protos.vision.shotlist.v1.VisionShotlistPreset"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: bool custom = 3;
   */
  custom: boolean;
};

/**
 * Describes the message protos.vision.shotlist.v1.VisionShotlistPreset.
 * Use `create(VisionShotlistPresetSchema)` to create a new message.
 */
export const VisionShotlistPresetSchema: GenMessage<VisionShotlistPreset> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_vision_shotlist_preset, 0);

/**
 * @generated from message protos.vision.shotlist.v1.VisionShotlistPresetBanks
 */
export type VisionShotlistPresetBanks = Message<"protos.vision.shotlist.v1.VisionShotlistPresetBanks"> & {
  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistPreset frame_size = 1;
   */
  frameSize: VisionShotlistPreset[];

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistPreset angle = 2;
   */
  angle: VisionShotlistPreset[];

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistPreset camera_movement = 3;
   */
  cameraMovement: VisionShotlistPreset[];

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistPreset equipment = 4;
   */
  equipment: VisionShotlistPreset[];
};

/**
 * Describes the message protos.vision.shotlist.v1.VisionShotlistPresetBanks.
 * Use `create(VisionShotlistPresetBanksSchema)` to create a new message.
 */
export const VisionShotlistPresetBanksSchema: GenMessage<VisionShotlistPresetBanks> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_vision_shotlist_preset, 1);

/**
 * @generated from enum protos.vision.shotlist.v1.VisionShotlistPresetCategory
 */
export enum VisionShotlistPresetCategory {
  /**
   * @generated from enum value: VISION_SHOTLIST_PRESET_CATEGORY_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VISION_SHOTLIST_PRESET_CATEGORY_FRAME_SIZE = 1;
   */
  FRAME_SIZE = 1,

  /**
   * @generated from enum value: VISION_SHOTLIST_PRESET_CATEGORY_ANGLE = 2;
   */
  ANGLE = 2,

  /**
   * @generated from enum value: VISION_SHOTLIST_PRESET_CATEGORY_CAMERA_MOVEMENT = 3;
   */
  CAMERA_MOVEMENT = 3,

  /**
   * @generated from enum value: VISION_SHOTLIST_PRESET_CATEGORY_EQUIPMENT = 4;
   */
  EQUIPMENT = 4,
}

/**
 * Describes the enum protos.vision.shotlist.v1.VisionShotlistPresetCategory.
 */
export const VisionShotlistPresetCategorySchema: GenEnum<VisionShotlistPresetCategory> = /*@__PURE__*/
  enumDesc(file_vision_shotlist_v1_vision_shotlist_preset, 0);

